import { render, staticRenderFns } from "./newCom.vue?vue&type=template&id=6f0aab0b&"
import script from "./newCom.vue?vue&type=script&lang=js&"
export * from "./newCom.vue?vue&type=script&lang=js&"
import style0 from "./newCom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports